import { Product2 } from "@lululemon/data-collection-types";
import { Product, Event } from "./types/hightouch";
import { LAM2 } from "./types/lam";

// This is our basic transformation
export function transformEvent(data: LAM2, anonymousId: string): Event {
  const event: Event = {
    originalTimestamp: new Date(data.timestamp * 1000).toISOString(),
    anonymousId: data.payload.user.session.digital_client_id || anonymousId,
    userId: data.payload.user.profile.hashedEmail,
    context: {
      campaign: {
        name: data.payload.user.session.attribution.utm_campaign,
        source: data.payload.user.session.attribution.utm_source,
        medium: data.payload.user.session.attribution.utm_medium,
        term: data.payload.user.session.attribution.utm_term,
        content: data.payload.user.session.attribution.utm_content,
      },
      locale: data.context.app.locale,
      page: {
        path: data.context.document.location.pathname,
        referrer: data.context.document.referrer,
        search: data.context.document.location.search,
        title: data.context.document.title,
        url: data.context.document.location.href,
      },
      userAgent: data.context.navigator.userAgent,
      sessionId: data.payload.user.session.id,
      // This is not normally collected by the browser API
      screen: {
        height: data.context.window.screen.height,
        width: data.context.window.screen.width,
      },
      // Neither is this
      geoIp: {
        city: data.payload.user.geoIp.city,
        region: data.payload.user.geoIp.region,
        country: data.payload.user.geoIp.country,
        zip: data.payload.user.geoIp.zip,
      },
      // This is metadata we need to determine what anonymous ID we are using
      anonymousIdSource: data.payload.user.session.digital_client_id
        ? "digital_client_id"
        : "anonymousId",
      appProperty: data.context.app.property,
    },
  };

  return event;
}

export function transformProducts(
  products: Record<string, Product2>,
  includeSkus: boolean
): Product[] {
  const transformed = Object.entries(products).reduce<Product[]>(
    (htProducts, [_, product]) => {
      if (!includeSkus) {
        let htProduct: Product = {
          category: product.categoryId,
          name: product.unifiedId,
          product_id: product.productId,
          sku: "",
          price: 0,
        };

        const defaultSku = Object.values(product.skus)[0];

        if (defaultSku) {
          htProduct = {
            ...htProduct,
            price: Number(
              (defaultSku.price.isSale
                ? defaultSku.price.sale
                : defaultSku.price.regular) || "0"
            ),
            sku: defaultSku.skuId,
          };
        }

        htProducts.push(htProduct);
      } else {
        for (const [skuId, sku] of Object.entries(product.skus)) {
          // Skip if it somehow already exists
          if (htProducts.some((p) => p.sku === skuId)) {
            continue;
          }

          htProducts.push({
            category: product.categoryId,
            name: product.unifiedId,
            price: Number(
              (sku.price.isSale ? sku.price.sale : sku.price.regular) || "0"
            ),
            sku: sku.skuId,
            product_id: product.productId,
            quantity: sku.quantity,
            variant: sku.size,
          });
        }
      }

      return htProducts;
    },
    []
  );

  return transformed;
}
